import { Pipe, PipeTransform } from '@angular/core';
import { upperCase } from 'lodash';

@Pipe({
  standalone: false,
    name: 'upperCase'
})
export class UpperCasePipe implements PipeTransform {

    transform(name: string): string {
        return upperCase(name);
    }
}
